import { Route } from "@angular/router";
import { UserEditComponent } from "./user-edit.component";
import { UserResolver } from "../shared/resolver/user-resolver";

export const UserEditRouting: Route = {
    path: ':user',
    component: UserEditComponent,
    resolve:{
        user: UserResolver
    },
    data: {
        breadcrumb: ":user.username"
    }
}
